import AutoLoadMoreIndicator from '@/components/AutoLoadMoreIndicator'
import Page from '@/components/Page'
import { SearchResult } from '@/components/Search'
import SearchBar from '@/components/Search/SearchBar'
import useSearch from '@/components/Search/useSearch'
import { createFileRoute } from '@tanstack/react-router'
import { useTitle } from 'react-use'
import { z } from 'zod'
import styles from './search.module.css'

const searchSchema = z.object({
	q: z.string().catch(''),
})

type SearchParams = z.infer<typeof searchSchema>

export const Route = createFileRoute('/search')({
	component: SearchPage,
	validateSearch: (search: SearchParams) => {
		const { q } = searchSchema.parse(search)
		return {
			q: decodeURIComponent(q),
		}
	},
})

function SearchPage() {
	const keywords = Route.useSearch({
		select: (params) => params.q,
	})

	const { data, words, fetchNext, isRefreshing, isFetchingMore } = useSearch(keywords)

	useTitle(`${keywords} - 即刻搜索`)
	return (
		<Page>
			<div className={styles.searchBar}>
				<SearchBar defaultValue={keywords} />
			</div>
			<SearchResult data={data} highlightWords={words} isLoading={isRefreshing} />
			<AutoLoadMoreIndicator
				isLoading={isFetchingMore}
				onLoadMore={async () => void (await fetchNext())}
			/>
		</Page>
	)
}
